





















import { TopBarBackMobile } from '@/components/TopBar'
import { defineComponent } from '@vue/composition-api'
import props from '../props'
import { forbidPageSetup, forbidPageRouterMobile } from '../logic'

export default defineComponent({
  name: 'ForbidPageMobile',
  components: { TopBarBackMobile },
  props,
  setup: forbidPageSetup,
  router: forbidPageRouterMobile
})
